var deliveryTimeMessages = {
  en: {
    "order_message": "Order in the next",
    "delivery_message": "to get it by",
    "hours": "hours",
    "minutes": "minutes"
  },
  sv: {
    "order_message": "Beställ inom",
    "delivery_message": "för att få paketet innan",
    "hours": "timmar",
    "minutes": "minuter"
  },
};
var htmlLang = document.documentElement.lang;
window.onload = function () {
  updateTimer();
  setInterval(updateTimer, 1000);
};

function updateTimer() {
  var endDate = new Date();
  endDate.setDate(endDate.getDate() + 2);

  // Hafta sonları dahil değilse, tarihi ileri al
  while (endDate.getDay() == 0 || endDate.getDay() == 6) {
    endDate.setDate(endDate.getDate() + 1);
  }

  // Teslimat tarihini hafta günü ve tarih olarak göster
  var dayOfWeek = endDate.toLocaleDateString(htmlLang, {weekday: "long"});
  dayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);


  var day = endDate.getDate().toString().padStart(2, '0');
  var month = (endDate.getMonth() + 1).toString().padStart(2, '0');
  var year = endDate.getFullYear().toString();

  var deliveryDate = `${dayOfWeek} ${day}/${month}/${year}`;


  // Bugünün tarih ve saatini al
  var date = new Date();
  var second = date.getSeconds();
  var minute = date.getMinutes();
  var hour = date.getHours();

  // Gün bitimine kalan süreyi hesapla (saat ve dakika cinsinden)
  var leftHour = 23 - hour;
  var leftMinute = 59 - minute;
  var leftSeconds = 59 - second;

  // Gün bitimine kalan süreyi saniye cinsinden hesapla
  var leftTime = (leftHour * 3600) + (leftMinute * 60) + leftSeconds;

  var h = Math.floor(leftTime / 3600);
  var m = Math.floor((leftTime - (h * 3600)) / 60);
  var s = Math.floor(leftTime % 60);

  if (!deliveryTimeMessages[htmlLang]) {
    htmlLang = "en";
  }

  var countdownLabel = deliveryTimeMessages[htmlLang].order_message + " <strong>" + h + " " + deliveryTimeMessages[htmlLang].hours + "</strong> <strong>" + m + " " + deliveryTimeMessages[htmlLang].minutes + "</strong> " + deliveryTimeMessages[htmlLang].delivery_message + " <strong>" + deliveryDate + "</strong>";                              // Etikette güncel kalan süreyi göster
  document.getElementById("delivery-countdown").innerHTML = countdownLabel;
  leftTime--;
}
